var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{staticClass:"m-t-15",attrs:{"fields":_vm.fields,"items":_vm.items,"head-variant":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }